<template>
  <div class="baseMapPickerContainer">
    <div>
      <b-button
        class="m-1 green"
        variant="primary"
        v-on:click="seen = !seen"
        style="width: 120px"
        title="Alkalmazás alaptérképe"
        v-b-tooltip.hover
        >{{ basemapName }}</b-button
      >
    </div>
    <div v-if="seen" id="basmeap_btns" style="width: 120px">
      <div>
        <b-button
          size="sm"
          variant="primary"
          @click="_SetBasemap('osm')"
          id="osm_btn"
          style="width: 120px"
          class="green"
          >OpenStreetMap</b-button
        >
      </div>
      <div>
        <b-button
          size="sm"
          variant="primary"
          @click="_SetBasemap('dark-gray')"
          id="dark-gray_btn"
          style="width: 120px"
          class="green"
          >Sötét szürke</b-button
        >
      </div>
      <div>
        <b-button
          size="sm"
          variant="primary"
          @click="_SetBasemap('topo')"
          id="topo_btn"
          style="width: 120px"
          class="green"
          >Topográfiai</b-button
        >
      </div>
      <div>
        <b-button
          size="sm"
          variant="primary"
          @click="_SetBasemap('satellite')"
          id="satellite_btn"
          style="width: 120px"
          class="green"
          >Légifotó</b-button
        >
      </div>
      <div>
        <b-button
          size="sm"
          variant="primary"
          @click="_SetBasemap('hybrid')"
          id="osm_btn"
          style="width: 120px"
          class="green"
          >Légifotó, felirattal</b-button
        >
      </div>
      <div>
        <b-button
          size="sm"
          variant="primary"
          @click="_SetBasemap('terrain')"
          id="osm_btn"
          style="width: 120px"
          class="green"
          >Domborzati</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseMapSelector",
  props: {
    map: Object,
  },
  data: function () {
    return {
      seen: false,
      basemapName: "Topográfiai",
    };
  },
  methods: {
    _SetBasemap(bm) {
      //this.map.setBasemap(bm);
      this.$store.state.map.changeBasemap(bm);
      switch (bm) {
        case "dark-gray":
          this.basemapName = "Sötét szürke";
          break;
        case "topo":
          this.basemapName = "Topográfiai";
          break;
        case "satellite":
          this.basemapName = "Légifotó";
          break;
        case "osm":
          this.basemapName = "OpenStreetMap";
          break;
        case "terrain":
          this.basemapName = "Domborzati";
          break;
        case "hybrid":
          this.basemapName = "Légifotó, felirattal";
          break;
      }
      this.seen = false;
      console.log("map object")
      console.log(this.map)
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.green {
 /* background-color: #28a745;
  border-color: #28a745;*/
  font-size: 1.25rem;
}
button {
  /*background-color: #28a745;
  border-color: #28a745;*/
  font-size: 1.25rem;
}
button:hover {
  /*background-color: #28a745;
  border-color: #28a745;*/
  font-size: 1.25rem;
}
button:focus {
  /*background-color: #28a745;
  border-color: #28a745;*/
  font-size: 1.25rem;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  /*background-color: #28a745;
  border-color: #28a745;*/
  font-size: 1.25rem;
}
>>>.tooltip-inner {
  background-color: white;
  color: black;
  border: 1px solid;
  border-color: black;
  font-size: 1.25em
}
</style>
